import styled from 'styled-components';

export const ApplyCouponDropdown = styled.div`
  position: relative;
  display: block;
  width: 100%;
  margin: 0 auto;
  font-size: clamp(12px, 2vw, 13px);
  color: hsl(0deg, 0%, 0%, 80%);
  font-weight: 500;
  // padding: 16px 14px 10px;

  .coupon_current {
    position: relative;
    border: solid 1px rgba(0, 0, 0, 0.1);
    border-right: none;

    outline: none;

    &.border_animate {
      animation: borderWidth 3.5s ease-out;
      @keyframes borderWidth {
        0% {
          border: solid 1.6px rgba(0, 0, 0, 0.8);
        }
        100% {
          border: solid 1px rgba(0, 0, 0, 0.1);
        }
      }
    }

    &:focus + .focusHolder {
      display: block;
      animation: none;

      .dropdown_option {
        @media (min-width: 720px) {
          cursor: pointer;
        }
      }
    }

    @media (min-width: 720px) {
      cursor: pointer;
    }
  }

  .not_applied_coupon {
    border: 1px solid #ef4e5e;
    width: 99.8%;
    margin-left: 0.2%;
  }

  .dropdown_icon {
    // width: 14px;
    transition: 0.2s ease;
    opacity: 0.6;
  }

  .down {
    transform: rotate(-180deg);
  }

  .cross_icon {
    font-size: 16px;
    font-weight: 500;
  }

  .dropdown_input {
    display: none;

    &:checked + .dropdown_text {
      display: flex;
      align-items: center;
    }
  }

  .dropdown_text {
    width: 100%;
    display: flex;
    align-items: center;
    justify-content: space-between;
    margin: 0;
    padding: 12px;

    .couponIcon {
      margin-right: 8px;
      height: 26px;
      width: 26px;
    }
  }

  .coupon_list {
    position: relative;
    width: 100%;
    padding: 0 12px 12px;
    list-style: none;
    display: block;
    background: #fff;
    z-index: 999;

    .couponListShow {
      height: 0;
      overflow: hidden;
      transition: all 0.3s ease-out;
      opacity: 0;
    }

    .couponListHide {
      height: 100%;
      opacity: 1;
      transition: all 1s ease-out;
    }
  }

  .coupon_list li {
    padding: 0;
    transition: all 0.3s ease-out;

    &.show {
      padding: 12px;
      display: flex;
      flex-direction: column;
      row-gap: 10px;
      border: dashed 1.4px #c1dfdc;
      margin: 10px 0;
      border-width: 2px;

      /* &:last-child {
                border-bottom: none;
            } */

      &:hover {
        color: hsl(0deg, 0%, 0%, 80%);
        background-color: #f1f1f1;
      }

      .valid_till_cart {
        display: flex;
        justify-content: space-between;
        align-items: center;

        p {
          font-size: 12px;
          font-weight: 500;
          opacity: 0.55;
          padding-right: 12px;
        }
      }
    }

    &.opaq {
      opacity: 0.6;
      pointer-events: none;
    }
  }

  .focusHolder {
    display: none;
    transition: all 0.4s ease-in-out;
  }

  .dropdown_text_only {
    display: flex;
    align-items: ${(props) => (props.toggle ? 'center' : 'flex-start')};
  }

  .dropdown_option {
    display: flex;
    justify-content: space-between;
    align-items: center;
    // padding: 8px 12px;
    column-gap: 16px;

    .dropdown_coupon_name {
      font-weight: 600;
    }

    .desc {
      font-size: clamp(11px, 2vw, 12px);
      color: hsl(0deg, 0%, 0%, 78%);
      letter-spacing: 0.28px;
    }

    &:focus {
      color: hsl(0deg, 0%, 0%, 80%);
      background-color: #f1f1f1;
    }

    @media (min-width: 720px) {
      cursor: pointer;
    }
  }

  @keyframes HideList {
    from {
      transform: scaleY(1);
    }
    to {
      transform: scaleY(0);
    }
  }

  .coupon_section {
    display: flex;
    flex-direction: column;
    opacity: 0.87;
    font-size: 13px;
    row-gap: 4px;
  }

  .bold_text {
    font-weight: 600;
  }

  .saving_price {
    color: #63b0a8;
    font-weight: 500;
    font-size: 12px;
    display: flex;
    column-gap: 5px;

    span {
      color: #ef4e5e;
    }
  }

  .errorMessageBox {
    font-size: 11px;
    font-weight: 300;
    color: #ff6174;
  }

  .offer_count {
    font-size: 12px;
    font-weight: 400;
  }

  .extraMargin {
    margin: 8px 0 16px;
    display: block;
  }

  .applicable_on {
    color: #63b0a8;
  }

  .view_all_products {
    color: #ef4e5e;
    display: flex;
    margin: 0px;
    padding: 0;
    width: fit-content;
    font-weight: bold;
    @media (min-width: 720px) {
      cursor: pointer;
    }
  }

  .coupon_image {
    position: relative;
  }

  .left_spike {
    position: absolute;
    left: -3px;
    top: 0;
    max-height: 100%;
  }

  .right_spike {
    position: absolute;
    right: -3px;
    top: 0;
    transform: rotate(180deg);
    max-height: 100%;
  }

  .low_opacity {
    opacity: 0.6;
  }

  .noPad {
    padding: 0px;
  }
`;

export const ApplyButton = styled.div`
  font-size: 12px;
  font-weight: 600;
  color: #ef4e5e;
  padding-left: 4px;
`;

export const AnimatedGif = styled.img`
  position: absolute;
  top: 0;
  width: 80%;
  z-index: ${(props) => (props.bogo ? '9999' : '3')};
  left: 50%;
  transform: translate(-50%, -30%);
`;

export const CouponApplyText = styled.p`
  display: block;
  font-size: 10px;
  font-weight: 500;
  color: hsl(0deg, 0%, 0%, 87%);
  position: relative;
  left: 4px;

  &.error_text {
    color: #ef4e5e;
  }

  &.succesfull_text {
    display: block;
    padding-bottom: 0;
    color: #63b0a8;
  }
`;
export const AddItemCta = styled.h5`
  @media (min-width: 720px) {
    cursor: pointer;
  }
`;

export const CouponInputContainer = styled.form`
  width: 100%;
  margin: 0;
  font-size: 12px;

  .textandbutton {
    display: flex;
    align-items: center;
  }

  .coupon_input_field {
    min-width: 65%;
    flex-basis: 65%;
    border: solid 1px rgba(112, 112, 112, 0.27);
    border-right: none !important;
    color: #000;
    opacity: 0.87;
    font-weight: 500;
    height: 36px;
    padding: 12px;
    border-radius: 2px 0px 0px 2px;
    background-color: #e5e7e7ad;
    border: none;
    &:focus {
      outline: none;
    }
  }

  .coupon_apply_button {
    min-width: 35%;
    flex-basis: 35%;
    border: solid 1px rgba(112, 112, 112, 0.27);
    height: 36px;
    display: flex;
    justify-content: flex-end;
    align-items: center;
    padding: 12px;
    opacity: 0.87;
    font-weight: 500;
    border-radius: 0px 2px 2px 0px;
    background-color: #e5e7e7ad;
    border: none;
    color: #ef4e5e;
    font-family: 'Montserrat';
    font-weight: 600;
    @media (min-width: 720px) {
      cursor: pointer;
    }
    &:disabled {
      color: #b3b3b3;
    }
  }
`;

export const CouponName = styled.div`
  // border-radius: 4px;
  // border: dashed 1px #63b0a8;
  // background-color: #eefef5;
  border: solid 1px #63b0a8;
  border-left: none;
  border-right: none;
  background-color: #f4f9f6;
  padding: 4px 10px;
  font-size: 12px;
  font-weight: 600;
  display: inline-block;
  // margin: 0 10px;
  text-transform: uppercase;
`;

export const CouponInputSubtext = styled.div`
  color: ${(props) => props.color || '#ef4e5e'};
  padding: 8px 4px 0;
  font-size: 10px;
`;
